import React, { useState, useEffect } from 'react';
import { rewardService } from '../api/services';
import AdminModal from './AdminModal';
import { formatDate } from '../utils/helpers';

// 後台：查看某商品「誰兌換了」的明細。依需求只記錄成功（APPROVED）的兌換。
const RewardRedemptionRecords = ({ item, onClose }) => {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    rewardService.itemRedemptions(item.id, 'APPROVED')
      .then((res) => { if (!cancelled) setRecords(res.data?.items || []); })
      .catch((err) => { if (!cancelled) setError(err.response?.data?.error || err.message); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [item.id]);

  const totalQty = records.reduce((s, r) => s + (r.quantity || 0), 0);
  const totalPoints = records.reduce((s, r) => s + (r.total_points || 0), 0);

  return (
    <AdminModal title={`兌換明細：${item.name}`} onClose={onClose}>
      {error && <div className="alert alert-danger">{error}</div>}
      {loading ? (
        <div className="reward-empty">載入中...</div>
      ) : records.length === 0 ? (
        <div className="reward-empty">此商品目前沒有成功兌換的紀錄</div>
      ) : (
        <>
          <p className="setting-desc">共 {records.length} 筆成功兌換、{totalQty} 件、合計扣點 {totalPoints}。</p>
          <div style={{ overflowX: 'auto' }}>
            <table className="reward-redemption-table">
              <thead>
                <tr><th>兌換人</th><th>數量</th><th>扣點</th><th>核准時間</th><th>核准者</th><th>備註</th></tr>
              </thead>
              <tbody>
                {records.map((r) => (
                  <tr key={r.id}>
                    <td>{r.user_name}</td>
                    <td>{r.quantity}</td>
                    <td>{r.total_points}</td>
                    <td>{r.reviewed_at ? formatDate(r.reviewed_at) : '-'}</td>
                    <td>{r.reviewer_name || '-'}</td>
                    <td>{r.note || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </AdminModal>
  );
};

export default RewardRedemptionRecords;
